import { Http, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import * as _ from 'lodash';

@Injectable()
export class RestService {
  public  serverError = false;
  protected baseUrl = 'https://mi-sg-api.unicorn.vn/api';
  protected hostUrl = window.location.origin;
  constructor(private _http: Http) { }

  protected get headers() {
    const headers = new Headers();
    const token: string = localStorage.getItem('token');
    console.log('token ' + token);
    _.set(headers, 'Authorization', 'Bearer ' + token);
    _.set(headers, 'Content-Type', 'application/json');

    return headers;
  }

  protected get(relativeUrl: string, isSelfHosted: boolean = false): Observable<any> {
    const url = !isSelfHosted ? this.baseUrl + relativeUrl : this.hostUrl + relativeUrl;
    return this._http.get(url, {
      headers: this.headers
    }).pipe(map(res => res.json()), catchError((err) => {
      this.serverError = true;
      alert('Internal Server Error');
      throw err;
    }));
  }

  protected post(relativeUrl: string, data: any, isSelfHosted: boolean = false): Observable<any> {
    const url = !isSelfHosted ? this.baseUrl + relativeUrl : this.hostUrl + relativeUrl;
    const options: RequestOptionsArgs = {
      method: 'POST',
      headers: this.headers,
      body: data
    };
    return this._http.request(url, options).pipe(map(res => res.json()), catchError((err) => {
      this.serverError = true;
      alert('Internal Server Error');
      throw err;
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/rest.service.ts